import { css } from 'styled-components';
import {
  getTypography, getSpacing, SpacingName, TypographyName, ThemedFunctor, BreakpointQueryName, grid, gridUnit,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALL,
  })}
`;

export const step: ThemedFunctor = ({
  theme,
  $size,
}) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALL,
    size: $size,
  })}
  display: flex;
`;

export const successStep: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.MEDIUM)}
  border: 2px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
  background-color: ${theme.palettes.neutrals.lightest};
  box-shadow: -20px 20px 20px 0 rgba(0,0,0,0.05);
  display: flex;
  max-width: 36rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    transform: translateY(-1rem);
  }
`;

export const successStepTitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)}
  color: ${theme.palettes.brand.primary};
`;

export const successStepDescription: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  max-width: 23rem;
  font-weight: normal;
`;

export const successStepImageWrapper: ThemedFunctor = ({ theme }) => css`
  display: none;
  flex: 1;
  text-align: center;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const howItWorksCTAImage = css`
  width: 6rem;
`;
